import React from 'react';
import './spinner.styles.css';

export const Spinner = () => (
  <div className="spinner">
    <div className="dot"></div>
  </div>
);
